'use client';
import { Divider } from '@mantine/core';

import { Button } from '@scaleup/frontend/ui';
import { IconArrowRight, IconCheck } from '@tabler/icons-react';
import { Sparkle } from 'lucide-react';
import Image from 'next/image';
import { useState } from 'react';
import { useSupplierIntakeContext } from './context';
import fetch from 'node-fetch';

export const Final = () => {  
  const { setCurrentStep, completeSupplierIntake } = useSupplierIntakeContext();
  const [nextStep, setNextStep] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleClick = async () => {
    // Call the API route to send the email
    setLoading(true);
    completeSupplierIntake().then(() => {
      setLoading(false);
    }).catch((error) => {
      console.error('Error completing supplier intake:', error);
      setLoading(false);
    });
  }
  const render = () => {
    return (
      <div className="flex flex-col gap-6">
        <p className="text-text-primary text-3xl font-bold">
          Supplier Intake Complete!
        </p>

        <p className="text-text-primary text-2xl font-semibold">
          Your "Industry Trends and Opportunities" report is being generated
          now.
        </p>

        <p className="text-text-primary">
          Thank you for completing the supplier intake form. This is the first step of your Scaleup Journey. As a token of our appreciation, we are generating a complimentary "Industry Trends and Opportunities" report tailored to your business. This report will provide valuable insights into current market trends and potential opportunities within your industry. You will receive this report via email within the next 24-48 hours.
        </p>

        <div className="w-[140px] pt-8">
          <Button
            variant="secondary"
            onClick={() => handleClick()}
            text="Complete"
            suffixIcon={<IconArrowRight />}
            loading={loading}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="rounded-[2rem] bg-primary-100 flex justify-between gap-8 p-16">
      <div className="flex items-center p-8 max-w-[40rem]">{render()}</div>
      <div className="hidden lg:flex items-center">
        <Image src="/supplier-intake.png" alt="" width={460} height={552} />
      </div>
    </div>
  );
};
